export default __webpack_public_path__ + "static/media/lisa.86bd6c7d.png";